import type { RateForDisplay } from './types/RateForDisplay';

export const isRateForDisplay = (obj: unknown): obj is RateForDisplay => {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'aprAsString' in obj &&
    typeof obj.aprAsString === 'string' &&
    'loanAmountAsString' in obj &&
    typeof obj.loanAmountAsString === 'string' &&
    'loanTermAsString' in obj &&
    typeof obj.loanTermAsString === 'string'
  );
};
